module.exports = __webpack_public_path__ + "img/pin.8c8c5137.svg";